import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query'
import { apiDelete, apiGet, apiUpload, apiZod } from '@/shared/api'
import { runtimeConfig } from '@/shared/config'
import { type Background, BackgroundSchema } from '../model/schema'
import { toBackground } from './mappers'

export const backgroundKeys = {
  all: ['backgrounds'] as const,
  list: () => [...backgroundKeys.all, 'list'] as const,
}

export const backgroundsQueryOptions = queryOptions({
  queryKey: backgroundKeys.list(),
  queryFn: async (): Promise<Background[]> => {
    const body = await apiGet('/backgrounds', apiZod.zListBackgroundsResponse)
    return (body.data ?? []).map((dto) => BackgroundSchema.parse(toBackground(dto)))
  },
})

// Same-origin поток файла — иначе VirtualBackground рисует tainted canvas.
export function backgroundFileUrl(id: string): string {
  return `${runtimeConfig.API_BASE_URL}/backgrounds/${id}/file`
}

export function useUploadBackgroundMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (file: File): Promise<Background> => {
      const body = await apiUpload('/backgrounds', apiZod.zUploadBackgroundResponse, file, {
        name: file.name,
      })
      return BackgroundSchema.parse(toBackground(body.data))
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: backgroundKeys.list() })
    },
  })
}

export function useDeleteBackgroundMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => apiDelete(`/backgrounds/${id}`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: backgroundKeys.list() })
    },
  })
}
